import $ from 'jquery';
import 'bootstrap-datepicker';
import parse from 'date-fns/parse';

const getDatepickerLeftArrow = () => {
  return '<button class="datepicker-button" type="button"><svg class="datepicker-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.286 15.106"><path d="M.792 7.553l7.994 6.502V1.05L.792 7.554z"/></svg></button>';
};

const getDatepickerRightArrow = () => {
  return '<button class="datepicker-button" type="button"><svg class="datepicker-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.286 15.106"><path d="M8.494 7.553L.5 1.05v13.005l7.994-6.502z"/></svg></button>';
};

/**
 * Convert a Gravity Forms datepicker format (eg. "dmy_dash") into a
 * bootstrap-datepicker compatible format (eg. "dd-mm-yyyy")
 *
 * @param {String} string Gravity Forms datepicker format.
 * @return {String} bootstrap-datepicker format.
 */
const convertDatepickerFormat = (string) => {
  const defaultFormat = 'mm/dd/yyyy';
  if (!string) {
    return defaultFormat;
  }
  switch (string) {
    case 'mdy':
      return 'mm/dd/yyyy';
    case 'dmy':
      return 'dd/mm/yyyy';
    case 'dmy_dash':
      return 'dd-mm-yyyy';
    case 'dmy_dot':
      return 'dd.mm.yyyy';
    case 'ymd_slash':
      return 'yyyy/mm/dd';
    case 'ymd_dash':
      return 'yyyy-mm-dd';
    case 'ymd_dot':
      return 'yyyy.mm.dd';
    default:
      return defaultFormat;
  }
};

/**
 * Convert a yyyy-mm-dd string into a Date object.
 *
 * @param {String} string Date in the format yyyy-mm-dd
 * @return {Date}
 */
const convertStringToDate = (string) => {
  if (!string) {
    return new Date();
  }
  return parse(string, 'yyyy-MM-dd', new Date());
};

/**
 * Initialize the datepicker on a specific <input> element
 * @param {Element} datepickerInput <input> element
 */
const initializeDatepicker = (datepickerInput) => {
  const $datepickerInput = $(datepickerInput);
  const datepickerID = $datepickerInput.attr('data-datepicker-id');
  const datepickerFormat = $datepickerInput.attr('data-datepicker-format');
  $datepickerInput.datepicker({
    autoclose: true,
    container: `[data-datepicker-container="${datepickerID}"]`,
    format: convertDatepickerFormat(datepickerFormat),
    maxViewMode: 2,
    startDate: new Date(),
    todayHighlight: true,
    templates: {
      leftArrow: getDatepickerLeftArrow(),
      rightArrow: getDatepickerRightArrow(),
    },
  });
};

/**
 * Initialize datepickers after render (including re-renders triggered by AJAX
 * submissions and/or conditional display rules)
 */
$(document).on('gform_post_render', function () {
  $('[data-datepicker-id]').each((index, datepicker) =>
    initializeDatepicker(datepicker)
  );
});
